// dbext:profile=staging_mcdo2019_be
import $ from "jquery";

export default class {

    init({ wrapper_class, post_url })
    {
        this.post_url = post_url;

        // can we find the wrapper class for the control?
        this.de_wrapper = $(wrapper_class);
        if ( this.de_wrapper.length === 0 ){
            return;
        }

        // set the html of the upload control
        this.set_html();

        // dom elements
        this.de_label        = this.de_wrapper.find('.js-upload__label'        );
        this.de_form         = this.de_wrapper.find('.js-upload__form'         );
        this.de_file_input   = this.de_wrapper.find('.js-upload__file-input'   );
        this.de_submit       = this.de_wrapper.find('.js-upload__submit'       );
        this.de_input_hidden = this.de_wrapper.find('.js-upload__input-hidden' );

        // "unnest" the form from the surrounding form, i.e. move it to the start of the body
        this.de_form.detach().prependTo('body');

        // event handlers
        this.de_file_input.on( 'change', this.on__file_input__change() );
        this.de_form.on      ( 'submit', this.on__form__submit() );

        // link the label to file input
        const id = 'id' + Math.floor( Math.random() * 999999 );
        this.de_label      .attr( 'for', id );
        this.de_file_input .attr( 'id' , id );
    }

    set_html()
    {
        // set this html fragment in the wrapper
        this.de_wrapper.html(
            `
                <style>
                    .js-upload__form, .js-upload__form * {
                        display: none;
                    }
                    .js-upload__label {
                        width: 250px;
                        height: 186px;
                        background-color: white;
                        font-weight: normal;
                        background-size: cover;
                        background-position: center;
                        border: 1px solid gray;
                    }
                    .js-upload__label.has-image {
                        text-indent: -1000px;
                        overflow: hidden;
                    }
                </style>
                <label class="js-upload__label" for="">
                    Click to set image...
                </label>
                <form class="js-upload__form" method="post" action="javascript:void(0)" enctype="multipart/form-data">
                    <input class="js-upload__file-input" name="csv_file_to_upload" type="file" accept="image/*" >
                    <input type="submit" class="js-upload__submit" >
                </form>
                <input type="hidden" name="image" value="" class="js-upload__input-hidden">
            `
        );
    }

    on__file_input__change()
    {
        return ( e ) => {

            // set files to upload
            this.files_to_upload = event.target.files;

            // submit the form
//          this.de_form.submit(); // this does not work in FF ⇒ fake clicking on the button
            this.de_submit.click();
        };
    }

    on__form__submit()
    {
        return ( e ) => {

            e.preventDefault();

            { // post data

                var data = new FormData();

                // pass files to upload
                $.each( this.files_to_upload, function(key, value){
                    data.append(key, value);
                } );
            }

            $.ajax({
                url         : this.post_url,
                type        : 'POST',
                data        : data  ,
                cache       : false ,
                dataType    : 'json',
                processData : false , // Don't process the files
                contentType : false , // Set content type to false as jQuery will tell the server it's a query string request
                success     : ( data, textStatus, jqXHR ) => {

                                let uploaded_image = data['uploaded-image'];
                                this.set_image( uploaded_image );
                            },
                error: function(jqXHR, textStatus, errorThrown)
                {
                    console.log('ERRORS: ' + textStatus);
                }
            });
        };
    }

    set_image( image_url )
    {
        this.de_label.css( 'background-image', 'url(' + image_url + ')' );
        this.de_label.addClass( 'has-image' );
        this.de_input_hidden.val( image_url );
    }
}

